var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShuruBloomContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.66 398.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m442.58,228.9c-.5,0-1,0-1.5-.1-8.2-.8-14.2-8.2-13.4-16.4,5-48.6-7.9-91.3-37.1-123.7-33.7-37.3-86.6-58.7-145.2-58.7s-111.5,21.4-145.2,58.7c-29.3,32.3-42.1,75.1-37.2,123.7.8,8.2-5.2,15.6-13.4,16.4-8.2.8-15.6-5.2-16.4-13.4-5.8-57.2,9.6-108,44.7-146.9C117.28,25,178.28,0,245.28,0s128.1,25,167.4,68.6c35.1,38.9,50.6,89.7,44.7,146.9-.7,7.7-7.2,13.4-14.8,13.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.28,398.8c-53.7,0-103.7-16.9-140.7-47.6-38.4-31.9-59.6-76.2-59.6-124.7s21.5-97.1,58.9-133.3c38.4-37.2,88.7-57.7,141.5-57.7s103.1,20.5,141.5,57.7c37.3,36.1,58.7,84.5,58.9,132.7v.6c0,48.5-21.2,92.8-59.7,124.7-37.1,30.7-87.1,47.6-140.8,47.6h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.28,398.8c-53.7,0-103.7-16.9-140.7-47.6-38.4-31.9-59.6-76.2-59.6-124.7s21.5-97.1,58.9-133.3c38.4-37.2,88.7-57.7,141.5-57.7s103.1,20.5,141.5,57.7c37.3,36.1,58.7,84.5,58.9,132.7v.6c0,48.5-21.2,92.8-59.7,124.7-37.1,30.7-87.1,47.6-140.8,47.6h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.58,228.9c-.5,0-1,0-1.5-.1-8.2-.8-14.2-8.2-13.4-16.4,5-48.6-7.9-91.3-37.1-123.7-33.7-37.3-86.6-58.7-145.2-58.7s-111.5,21.4-145.2,58.7c-29.3,32.3-42.1,75.1-37.2,123.7.8,8.2-5.2,15.6-13.4,16.4-8.2.8-15.6-5.2-16.4-13.4-5.8-57.2,9.6-108,44.7-146.9C117.28,25,178.28,0,245.28,0s128.1,25,167.4,68.6c35.1,38.9,50.6,89.7,44.7,146.9-.7,7.7-7.2,13.4-14.8,13.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.68,198.4c-8.7,0-23.4-2.7-53-23.5-1.3,2.2-3,4.3-4.9,6.3-5.2,5.5-14.8,12-30.5,12s-25.3-6.5-30.5-12c-1.9-2-3.5-4.1-4.9-6.3-29.6,20.8-44.2,23.5-53,23.5-9.6,0-17.8-4-22.9-11.2-2.5-3.6-4.3-7.8-5.2-12.8-18.3,13-37,23.3-51.6,23.3-8.8,0-16.4-3.6-21.2-10.2-7.2-9.8-7.5-25.1-1-45.5,4.3-13.6,19-43.6,46.7-70.3,37.1-35.7,86.7-55.2,143.3-56.4h.6c56.6,1.2,106.1,20.7,143.3,56.4,27.8,26.7,42.4,56.8,46.7,70.3,6.5,20.4,6.1,35.7-1,45.5-4.8,6.6-12.3,10.2-21.2,10.2h0c-14.6,0-33.3-10.3-51.6-23.3-.9,4.6-2.5,9-5.2,12.8-5.1,7.2-13.3,11.2-22.9,11.2Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.68,198.4c-8.7,0-23.4-2.7-53-23.5-1.3,2.2-3,4.3-4.9,6.3-5.2,5.5-14.8,12-30.5,12s-25.3-6.5-30.5-12c-1.9-2-3.5-4.1-4.9-6.3-29.6,20.8-44.2,23.5-53,23.5-9.6,0-17.8-4-22.9-11.2-2.5-3.6-4.3-7.8-5.2-12.8-18.3,13-37,23.3-51.6,23.3-8.8,0-16.4-3.6-21.2-10.2-7.2-9.8-7.5-25.1-1-45.5,4.3-13.6,19-43.6,46.7-70.3,37.1-35.7,86.7-55.2,143.3-56.4h.6c56.6,1.2,106.1,20.7,143.3,56.4,27.8,26.7,42.4,56.8,46.7,70.3,6.5,20.4,6.1,35.7-1,45.5-4.8,6.6-12.3,10.2-21.2,10.2h0c-14.6,0-33.3-10.3-51.6-23.3-.9,4.6-2.5,9-5.2,12.8-5.1,7.2-13.3,11.2-22.9,11.2Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.98,326.9c-23.2,0-42-18.9-42-42s18.9-42,42-42,42,18.9,42,42-18.8,42-42,42Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.63,
    cy: 284.77,
    r: 42,
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.18,328.9c-2.1,0-4.3,0-6.4-.1-10-.3-18.1-8.3-19-18.5L.08,179.9c-.9-10.3,5.7-19.5,15.5-21.6,13.5-2.9,27.4-4.4,41.2-4.4,2.1,0,4.3,0,6.4.1,10,.3,18.1,8.3,19,18.5l11.6,130.4c.9,10.3-5.7,19.5-15.5,21.6-13.4,3-27.3,4.4-41.1,4.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.18,328.9c-2.1,0-4.3,0-6.4-.1-10-.3-18.1-8.3-19-18.5L.08,179.9c-.9-10.3,5.7-19.5,15.5-21.6,13.5-2.9,27.4-4.4,41.2-4.4,2.1,0,4.3,0,6.4.1,10,.3,18.1,8.3,19,18.5l11.6,130.4c.9,10.3-5.7,19.5-15.5,21.6-13.4,3-27.3,4.4-41.1,4.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.48,328.9c-13.8,0-27.7-1.5-41.2-4.4-9.7-2.1-16.4-11.3-15.5-21.6l11.7-130.4c.9-10.2,9.1-18.2,19-18.5,2.1-.1,4.3-.1,6.4-.1,13.8,0,27.7,1.5,41.2,4.4,9.7,2.1,16.4,11.3,15.5,21.6l-11.7,130.4c-.9,10.2-9.1,18.2-19,18.5-2.1.1-4.3.1-6.4.1Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.48,328.9c-13.8,0-27.7-1.5-41.2-4.4-9.7-2.1-16.4-11.3-15.5-21.6l11.7-130.4c.9-10.2,9.1-18.2,19-18.5,2.1-.1,4.3-.1,6.4-.1,13.8,0,27.7,1.5,41.2,4.4,9.7,2.1,16.4,11.3,15.5,21.6l-11.7,130.4c-.9,10.2-9.1,18.2-19,18.5-2.1.1-4.3.1-6.4.1Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.28,264.6c-7,0-13.2-4.9-14.7-11.9-2.2-10.5-8.7-14.2-14.1-14.2s-11.9,3.7-14.1,14.2c-1.7,8.1-9.6,13.3-17.7,11.6-8.1-1.7-13.3-9.6-11.6-17.7,4.7-22.8,22.2-38.1,43.5-38.1s38.7,15.3,43.5,38.1c1.7,8.1-3.5,16.1-11.6,17.7-1.1.2-2.2.3-3.2.3h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.88,264.6c-7,0-13.2-4.9-14.7-11.9-2.2-10.5-8.7-14.2-14.1-14.2s-11.9,3.7-14.1,14.2c-1.7,8.1-9.6,13.3-17.7,11.6-8.1-1.7-13.3-9.6-11.6-17.7,4.7-22.8,22.2-38.1,43.5-38.1h0c21.2,0,38.7,15.3,43.5,38.1,1.7,8.1-3.5,16.1-11.6,17.7-1.2.2-2.2.3-3.2.3h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.88,322.3c-26.3,0-50-13.5-63.4-36.2-4.2-7.1-1.9-16.3,5.3-20.5,7.1-4.2,16.3-1.9,20.5,5.3,7.9,13.4,22,21.5,37.6,21.5s29.7-8,37.6-21.5c4.2-7.1,13.4-9.5,20.5-5.3s9.5,13.4,5.3,20.5c-13.4,22.7-37.1,36.2-63.4,36.2Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.08,213.9C35.08,86.5,136.38,15,245.28,15s210.2,71.5,197.2,198.9",
    fill: "#f05289",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.68,226.5c0,92.1-83,157.3-185.4,157.3S59.98,318.5,59.98,226.5,142.98,50.5,245.38,50.5s185.3,83.9,185.3,176h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.68,226.5c0,92.1-83,157.3-185.4,157.3S59.98,318.5,59.98,226.5,142.98,50.5,245.38,50.5s185.3,83.9,185.3,176h0Z",
    fill: "none",
    stroke: "#020500",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.08,213.9C35.08,86.5,136.38,15,245.28,15s210.2,71.5,197.2,198.9",
    fill: "none",
    stroke: "#020500",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.28,30.4c-126.3,2.6-170.2,97.8-176,116.2-6,19.1-17.7,73.8,78.1-5.6,0,0-30.9,89.2,70.8,9,0,0-1.2,28.2,27.1,28.2s27.1-28.2,27.1-28.2c101.7,80.2,70.8-9,70.8-9,95.8,79.5,84.1,24.7,78.1,5.6-5.8-18.4-49.7-113.6-176-116.2Z",
    fill: "#ffc6e4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.28,30.4c-126.3,2.6-170.2,97.8-176,116.2-6,19.1-17.7,73.8,78.1-5.6,0,0-30.9,89.2,70.8,9,0,0-1.2,28.2,27.1,28.2s27.1-28.2,27.1-28.2c101.7,80.2,70.8-9,70.8-9,95.8,79.5,84.1,24.7,78.1,5.6-5.8-18.4-49.7-113.6-176-116.2Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.98,
    cy: 284.8,
    r: 27,
    fill: "#ffc6e4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.58,
    cy: 284.8,
    r: 27,
    fill: "#ffc6e4",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.28,313.8c14.8.5,29.5-.8,44-3.9,2.3-.5,3.9-2.9,3.7-5.6-3.9-43.5-7.8-87-11.7-130.4-.2-2.7-2.2-4.8-4.6-4.9-14.8-.5-29.5.8-44,3.9-2.3.5-3.9,2.9-3.6,5.6,3.9,43.5,7.8,87,11.6,130.4.2,2.8,2.2,4.9,4.6,4.9Z",
    fill: "#f05289",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.28,313.8c14.8.5,29.5-.8,44-3.9,2.3-.5,3.9-2.9,3.7-5.6-3.9-43.5-7.8-87-11.7-130.4-.2-2.7-2.2-4.8-4.6-4.9-14.8-.5-29.5.8-44,3.9-2.3.5-3.9,2.9-3.6,5.6,3.9,43.5,7.8,87,11.6,130.4.2,2.8,2.2,4.9,4.6,4.9Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.38,313.8c-14.8.5-29.5-.8-44-3.9-2.3-.5-3.9-2.9-3.6-5.6,3.9-43.5,7.8-87,11.6-130.4.2-2.7,2.2-4.8,4.6-4.9,14.8-.5,29.5.8,44,3.9,2.3.5,3.9,2.9,3.6,5.6-3.9,43.5-7.8,87-11.6,130.4-.2,2.8-2.2,4.9-4.6,4.9Z",
    fill: "#f05289",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.38,313.8c-14.8.5-29.5-.8-44-3.9-2.3-.5-3.9-2.9-3.6-5.6,3.9-43.5,7.8-87,11.6-130.4.2-2.7,2.2-4.8,4.6-4.9,14.8-.5,29.5.8,44,3.9,2.3.5,3.9,2.9,3.6,5.6-3.9,43.5-7.8,87-11.6,130.4-.2,2.8-2.2,4.9-4.6,4.9Z",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.28,249.6c-7.3-34.8-50.3-34.8-57.5,0",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.88,249.6c-7.3-34.8-50.3-34.8-57.5,0",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.38,278.5c-22.7,38.4-78.3,38.4-101.1,0",
    fill: "none",
    stroke: "#020500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuruBloomContent);
export default __webpack_public_path__ + "static/media/shuru_bloom_content.16c75d37c9bb9b9c595a642d903df0a2.svg";
export { ForwardRef as ReactComponent };